export default __webpack_public_path__ + "d4c2bf0a6d092c3ed5748f9e74c05462.png";